import ActionsForm from '@/shared/mixins/actionsForm'
import aprTemplateRiskCauseConsequenceSourceMeasuresRepository from '@/shared/http/repositories/business/aprTemplateRiskCauseConsequenceSourceMeasures'
import aprTemplate from '@/shared/http/repositories/business/aprTemplate'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'addEpiApr',
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      cancelaRisco: false,
      selectedDescription: null,
      causaDescricao: null,
      medidaDescricaoVizualizacao: null,
      ConsequenciaDescricaoVisualizacao: null,
      formAddRisco: {
        naturezaRisco: null,
        fonteGeradora: null,
        consequecias: null,
        medidasDeControle: null,
        observacao: null
      },
      // Edicao: false,
      dataEdicaoCausa: {},
      dataCausa: [],
      dataFonte: [],
      dataConsequencia: [],
      dataMedidaControle: [],
      dataMedidaControleCompleto: [],
      selected: null
    }
  },

  props: {
    SemEtapaServico: {
      type: Boolean,
      default: false
    },
    aprVisualizacao: {
      type: Boolean,
      default: false
    },
    etapaServicoId: {
      type: String,
      default: ''
    },
    idRisco: {
      type: String,
      default: ''
    },
    idCausa: {
      type: String,
      default: ''
    },
    idFonte: {
      type: String,
      default: ''
    },
    idConseguencia: {
      type: String,
      default: ''
    },
    idMedida: {
      type: String,
      default: ''
    },
    idAPRTemplate: {
      type: String,
      default: ''
    },
    causaMedidaFonteId: {
      type: String,
      default: ''
    },
    revisao: {
      type: Number,
      default: 0
    },
    revisaoPopUp: {
      type: Number,
      default: 0
    },
    UpAprEdicao: {
      type: Boolean,
      default: false
    },
    causaAgEnvio: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: {}
    }
  },

  watch: {
  },

  mounted () {
    if ((this.UpAprEdicao === true || this.aprVisualizacao === true) && this.causaAgEnvio === false) {
      this.onloadDetalhesEdicao()
    } else if (this.causaAgEnvio === true) {
      this.onloadDetalhesEdicaoAgAprovacao(this.item)
    }
    if (this.UpAprEdicao !== true) {
      this.onLoadNaturezaRisco()
    }
    this.onLoadFonte()
    this.onLoadConsequencia()
    this.onLoadMedidaControle()
  },
  methods: {
    selectOption (id, descricao) {
      this.formAddRisco.medidasDeControle = id
      this.selectedDescription = descricao
    },
    cancel () {
      this.cancelaRisco = !this.cancelaRisco
      this.$emit('cancelaRisco', this.cancelaRisco)
    },
    onLoadNaturezaRisco () {
      loading.push()
      aprTemplateRiskCauseConsequenceSourceMeasuresRepository.GetCausas({RiscoId: this.idRisco, APRTemplateID: this.idAPRTemplate, CausaEdicaoId: this.UpAprEdicao === true ? this.formAddRisco.naturezaRisco : null, EtapaServicoId: this.SemEtapaServico === true ? null : this.etapaServicoId})
        .then((Response) => {
          loading.pop()
          this.dataCausa = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    onLoadFonte () {
      loading.push()
      aprTemplateRiskCauseConsequenceSourceMeasuresRepository.GetFonte()
        .then((Response) => {
          loading.pop()
          this.dataFonte = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    onLoadConsequencia () {
      loading.push()
      aprTemplateRiskCauseConsequenceSourceMeasuresRepository.GetConsequencia()
        .then((Response) => {
          loading.pop()
          this.dataConsequencia = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    onLoadMedidaControle () {
      loading.push()
      aprTemplateRiskCauseConsequenceSourceMeasuresRepository.GetMedidaControle()
        .then((Response) => {
          loading.pop()
          this.dataMedidaControle = Response.data.data.map(item => {
            return {
              ...item,
              descricao: item.descricao.slice(0, 90) // Limita a descrição a 10 caracteres
            }
          })
          this.dataMedidaControleCompleto = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    onloadDetalhesEdicao () {
      if (this.idAPRTemplate !== '' && this.idAPRTemplate !== undefined && this.idCausa !== '' && this.idCausa !== undefined && this.idRisco !== '' && this.idRisco !== undefined && this.revisao !== -1 && this.revisao !== undefined) {
        loading.push()
        this.Edicao = true
        if (this.causaAgEnvio === true) {
          this.formAddRisco.naturezaRisco = this.idCausa
          this.formAddRisco.fonteGeradora = this.idFonte
          this.formAddRisco.consequecias = this.idConseguencia
          this.formAddRisco.medidasDeControle = this.idMedida
        } else {
          aprTemplate.GetEdicaoAPRTemplateDetalhesRiscoCausaById({APRId: this.idAPRTemplate, CausaId: this.idCausa, RiscoId: this.idRisco, Revisao: this.revisaoPopUp === undefined || this.revisaoPopUp == null ? this.revisao : this.revisaoPopUp})
            .then((Response) => {
              loading.pop()
              this.dataEdicaoCausa = Response.data.data[0]
              this.formAddRisco.naturezaRisco = Response.data.data[0].itens[0].causaId
              this.formAddRisco.fonteGeradora = Response.data.data[0].itens[0].fonteId
              this.formAddRisco.consequecias = Response.data.data[0].itens[0].conseguenciaId
              this.formAddRisco.medidasDeControle = Response.data.data[0].itens[0].medicaId
              this.formAddRisco.observacao = Response.data.data[0].itens[0].observacao
              this.medidaDescricaoVizualizacao = Response.data.data[0].itens[0].medidaControleDescricao
              this.ConsequenciaDescricaoVisualizacao = Response.data.data[0].itens[0].consequenciaDescricao
              this.onLoadNaturezaRisco()
            }).catch(Error => {
              loading.pop()
              toast.error('Erro ao carregar as informações')
            })
        }
      }
    },
    onloadDetalhesEdicaoAgAprovacao (Response) {
      this.formAddRisco.naturezaRisco = Response.causaId.id === undefined ? Response.causaId : Response.causaId.id
      this.formAddRisco.fonteGeradora = Response.fonteId.id === undefined ? Response.fonteId : Response.fonteId.id
      this.formAddRisco.consequecias = Response.conseguenciaId.id === undefined ? Response.conseguenciaId : Response.conseguenciaId.id
      this.formAddRisco.medidasDeControle = Response.medicaId.id === undefined ? Response.medicaId : Response.medicaId.id
      this.formAddRisco.observacao = Response.observacao
      this.medidaDescricaoVizualizacao = Response.medidaControleDescricao
      this.ConsequenciaDescricaoVisualizacao = Response.consequenciaDescricao
      this.Edicao = true
    },
    handleNaturezaRiscoChange () {
      const selectedId = this.formAddRisco.naturezaRisco
      const selectedData = this.dataCausa.find(data => data.id === selectedId)
      if (selectedData) {
        this.descricaoCausa(selectedData)
      }
    },
    descricaoCausa (data) {
      this.causaDescricao = data.descricao
    },
    Adicionar () {
      if (this.formAddRisco.naturezaRisco != null && this.formAddRisco.naturezaRisco !== undefined && this.formAddRisco.fonteGeradora != null && this.formAddRisco.fonteGeradora !== undefined && this.formAddRisco.consequecias != null && this.formAddRisco.consequecias !== undefined && this.formAddRisco.medidasDeControle != null && this.formAddRisco.medidasDeControle !== undefined) {
        let value = {
          descricaoStatus: 'AG. ENVIO',
          colorStatusAPR: '#dfdfdf',
          causaDescricao: this.causaDescricao === null ? this.formAddRisco.naturezaRisco.descricao : this.causaDescricao,
          causaId: this.Edicao === false ? (typeof this.formAddRisco.naturezaRisco === 'object' ? this.formAddRisco.naturezaRisco.id : this.formAddRisco.naturezaRisco) : (typeof this.formAddRisco.naturezaRisco === 'object' ? this.formAddRisco.naturezaRisco.id : this.formAddRisco.naturezaRisco),
          fonteId: this.formAddRisco.fonteGeradora,
          medicaId: this.formAddRisco.medidasDeControle,
          conseguenciaId: this.formAddRisco.consequecias,
          classificacao: null,
          classificacaoDescricao: null,
          colorClassificacao: 'rgb(203, 233, 207)',
          colorFonteClassificacao: null,
          dataCriacaoCausa: null,
          probabilidade: null,
          probabilidadeDescricao: null,
          severidade: null,
          severidadeDescricao: null,
          observacao: this.formAddRisco.observacao
        }
        if (this.Edicao === true) {
          let itens = {emMemoria: true, edicao: this.Edicao, riscoId: this.idRisco, causaid: this.idCausa, etapaServicoId: this.etapaServicoId, value}

          let itensId = {
            etapaServicoId: this.etapaServicoId,
            emMemoria: true,
            causaid: this.idCausa,
            riscoId: this.idRisco,
            causaConseguenciaMedidaFonteId: this.causaMedidaFonteId,
            itens:
            {
              naturezaRisco: this.formAddRisco.naturezaRisco,
              fonteGeradora: this.formAddRisco.fonteGeradora,
              consequecias: this.formAddRisco.consequecias,
              medidasDeControle: this.formAddRisco.medidasDeControle,
              observacao: this.formAddRisco.observacao
            }
          }
          this.cancel()
          if (this.causaAgEnvio === false) {
            this.$emit('editarRiscoFonteConsequenciaMedidaItens', itensId)
          }
          this.$emit('RiscoFonteMedidaConsequencia', itens)
        } else {
          let itens = {emMemoria: true, edicao: this.Edicao, riscoId: this.idRisco, etapaServicoId: this.etapaServicoId, value}

          let itensId = {
            etapaServicoId: this.etapaServicoId,
            emMemoria: true,
            riscoId: this.idRisco,
            itens:
            {
              naturezaRisco: this.formAddRisco.naturezaRisco.id,
              fonteGeradora: this.formAddRisco.fonteGeradora.id,
              consequecias: this.formAddRisco.consequecias.id,
              medidasDeControle: this.formAddRisco.medidasDeControle.id,
              observacao: this.formAddRisco.observacao
            }
          }
          this.removerCausaSelecionada(this.formAddRisco.naturezaRisco)
          this.$emit('salvarRiscoFonteConsequenciaMedidaItens', itensId)
          this.$emit('RiscoFonteMedidaConsequencia', itens)
        }
      } else {
        toast.warning('Informações todas as informações devem ser selecionadas!')
      }
    },
    removerCausaSelecionada (causaId) {
      const index = this.dataCausa.findIndex(causa => causa.id === (typeof this.formAddRisco.naturezaRisco === 'object' ? this.formAddRisco.naturezaRisco.id : this.formAddRisco.naturezaRisco))

      // Se o índice for encontrado (diferente de -1), remove o item
      if (index !== -1) {
        this.dataCausa.splice(index, 1)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/addRisk/addRisk.js